import React from "react";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import Layout from "../../components/Layout/Layout";
import { useState, useEffect } from "react";
import NewsServices from "./../../services/NewsServices";
import fire from "./../../utils/Toastr";
import CustomerServices from "../../services/CustomerServices";
import { SearchIcon } from "@heroicons/react/solid";
import DatePicker from "react-date-picker";
import {
  formatDate,
  formatDateForDisplay,
} from "../../utils/convertDate";
import Paginate from "../../utils/Paginate";

export default function PushNotification() {
  const initialFormValues = {
    title: "",
    content: "",
    targetedUserName: "",
  };
  const initialFormErrors = {
    titleError: "",
    contentError: "",
    formIsSubmitting: false,
  };

  const [customer, setCustomer] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState({ loading: false });
  const [pageIndex, setPageIndex] = useState(1);
  const [prevPage, setPrev] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [totalPage, setPage] = useState(0);
  const [nextPage, setNextPage] = useState(false);
  const [formValues, setFormValues] = useState(initialFormValues);
  const [formErrors, setFormErrors] = useState(initialFormErrors);
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const [stage, setStage] = useState("");
  const [formDates, setFormDates] = useState({
    from: new Date(new Date().setDate(new Date().getDate() - 7)),
    to: new Date(),
  });

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
  };

  const handleUserChange = (e) => {
    setFormValues((prev) => ({
      ...prev,
      targetedUserName: e.target.value,
    }));
  };

  const fetchCustomers = async () => {
    const response = await CustomerServices.listCustomers(
      pageIndex,
      10,
      search,
      from,
      to,
      stage
    );
    setCustomer(response.data.result);
    setPageNumber(response.data.totalCount);
    setPageIndex(response.data.pageIndex);
    setPrev(response.data.hasPreviousPage);
    setNextPage(response.data.hasNextPage);
    setPage(response.data.totalPages);
  };

  const dateValidation = {
    fromHandler: (event) => {
      setFormDates({ ...formDates, from: event });
    },
    toHandler: (event) => {
      setFormDates({ ...formDates, to: event });
    },
  };

  const handleDateRange = async (e) => {
    e.preventDefault();
    const newDate = formatDate(formDates.from);
    setFrom(formatDate(newDate));

    const toDate = formatDate(formDates.to);
    setTo(formatDate(toDate));

    await fetchCustomers();
  };

  const setSort = async (e) => {
    if (e.target.value === "All" || e.target.value === "sort") {
      setStage("");
    } else {
      setStage(e.target.value);
    }
    await fetchCustomers();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    // Validate fields
    let valid = true;

    if (formValues.title.trim().length < 1) {
      setFormErrors((prev) => ({
        ...prev,
        titleError: "Title cannot be empty",
        titleIsValidated: false,
      }));
      valid = false;
    } else {
      setFormErrors((prev) => ({
        ...prev,
        titleError: "",
        titleIsValidated: true,
      }));
    }

    if (formValues.content.trim().length < 1) {
      setFormErrors((prev) => ({
        ...prev,
        contentError: "Content cannot be empty",
        contentIsValidated: false,
      }));
      valid = false;
    } else {
      setFormErrors((prev) => ({
        ...prev,
        contentError: "",
        contentIsValidated: true,
      }));
    }

    if (!valid) {
      setLoading(false);
      fire("error", "Please fill in all required fields.");
      return;
    }

    try {
      const response = await NewsServices.singleUserNotification(formValues);
      if (response) {
        fire("success", response.message);
        setTimeout(() => {
          window.location.href = "/posts";
        }, 2000);
      }
    } catch (error) {
      fire("error", "An error occurred while submitting the form");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCustomers();
  }, [pageIndex, stage]);

  return (
    <>
      <Layout title={""} pageTag={"news"} current={"/push/notification"}>
        <React.Fragment>
          <main>
            <div className="py-6">
              <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
                <h1 className="text-2xl font-semibold text-gray-900">
                  Push Notification
                </h1>
              </div>
            </div>
            <div className="flex">
              <div className=" relative rounded-md shadow-sm ">
                <p className="text-sm leading-3 text-gray-500">From</p>
                <div>
                  <DatePicker
                    onChange={dateValidation.fromHandler}
                    value={formDates.from}
                  />
                </div>
              </div>
              <div className=" relative rounded-md shadow-sm ml-3">
                <p className="text-sm leading-3 text-gray-500">To</p>
                <div>
                  <DatePicker
                    onChange={dateValidation.toHandler}
                    value={formDates.to}
                  />
                </div>
              </div>
              <div className="mt-5 ml-4 relative rounded-md shadow-sm">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <SearchIcon
                    className="h-5 w-5 text-gray-400"
                    aria-hidden="true"
                  />
                </div>
                <input
                  type="text"
                  onChange={handleSearchChange}
                  value={search}
                  name="search"
                  id="search"
                  className="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-10 sm:text-sm border-gray-300 rounded-md"
                  placeholder="Search "
                />
              </div>
              <div className="mt-5 ml-4">
                <button
                  onClick={handleDateRange}
                  className="hover:text-white active:text-white inline-flex mr-2 items-center justify-center rounded-md border border-transparent btn-green px-6 py-2 text-sm font-medium text-green shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto"
                >
                  Search
                </button>
              </div>
              <div className="mt-5 relative rounded-md shadow-sm ml-3">
                <select
                  id="currency"
                  name="currency"
                  onChange={(e) => setSort(e)}
                  placeholder="Sort by"
                  className="focus:ring-indigo-500 focus:border-indigo-500 h-full py-0 pl-2 pr-7 border-gray-300 bg-transparent text-gray-500 sm:text-sm rounded-md"
                >
                  <option value={"sort"}>Sort by</option>
                  <option value={"All"}>All</option>
                  <option value={"Started"}>Started</option>
                  <option value={"BvnVerified"}>BVN Verification</option>
                  <option value={"OtpSent"}>Otp Sent</option>
                  <option value={"OtpVerified"}>Otp Verified</option>
                  <option value={"OnboardingCompleted"}>
                    Onboarding completed
                  </option>
                  <option value={"VerificationMailSent"}>
                    Verification sent
                  </option>
                  <option value={"MailVerified"}>Mail verified</option>
                  <option value={"Completed"}>Completed</option>
                </select>
              </div>
            </div>
            <div className="flex justify-between items-center mb-8 float-right">
              <label className="inline-flex items-center">
                <input type="checkbox" className="form-checkbox" />
                <span className="ml-2">Send to multiple users</span>
              </label>
            </div>

            <div className="max-w-7xl mt-5 mx-auto px-4 sm:px-6 md:px-8">
              {customer.length === 0 ? (
                <div className=" mt-8 mb-4">
                  {" "}
                  No data available for these to show.{" "}
                </div>
              ) : (
                <>
                  <table className="min-w-full table-fixed divide-y divide-gray-300">
                    <thead>
                      <tr>
                        <th className="px-3"></th>
                        <th
                          scope="col"
                          className="min-w-[8rem] pl-4 py-3.5 pr-3 italic font-normal text-left text-sm  text-gray-900"
                        >
                          Username
                        </th>
                        <th
                          scope="col"
                          className="min-w-[10rem] py-3.5 pr-3 italic font-normal text-left text-sm  text-gray-900"
                        >
                          Account Name
                        </th>
                        <th
                          scope="col"
                          className="min-w-[10rem] py-3.5 pr-3 italic font-normal text-left text-sm  text-gray-900"
                        >
                          BVN
                        </th>
                        <th
                          scope="col"
                          className="min-w-[8rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-900"
                        >
                          Email Address
                        </th>
                        <th
                          scope="col"
                          className="min-w-[8rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-900"
                        >
                          Registration Status
                        </th>
                        <th
                          scope="col"
                          className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-900"
                        >
                          Phone Number
                        </th>
                        <th
                          scope="col"
                          className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-900"
                        >
                          Date Created
                        </th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-200 bg-white">
                      {customer.map((person, i) => (
                        <tr key={i} className="bg-gray-50">
                          <td className="relative w-12 px-6 sm:w-16 sm:px-8">
                            <input
                              type="radio"
                              value={person.userName}
                              name="user"
                              id={person.userName}
                              onChange={handleUserChange}
                            />
                          </td>
                          <td className="whitespace-nowrap  pl-4 py-4 pr-3 text-sm font-medium text-indigo-600">
                            {person.userName == null ? "N/A" : person.userName}
                          </td>
                          <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                            {person.surname} {person.firstName}
                          </td>
                          <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                            {person.bvn}
                          </td>
                          <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                            {person.emailAddress}
                          </td>
                          <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                            {person.registrationStage}
                          </td>
                          <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                            {person.phoneNumber == null
                              ? "N/A"
                              : person.phoneNumber}
                          </td>
                          <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                            {formatDateForDisplay(person.dateCreated)}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <Paginate
                    nextPage={nextPage}
                    pageIndex={pageIndex}
                    totalCount={pageNumber}
                    totalPages={totalPage}
                    prevPage={prevPage}
                    setPrevPage={setPrev}
                    setPageIndex={setPageIndex}
                    handlePrevPage={() => {
                      setPageIndex(pageIndex - 1);
                    }}
                    handleNextPage={() => {
                      setPageIndex(pageIndex + 1);
                    }}
                  />
                </>
              )}
              <hr className="border border-gray-600 w-full" />
              <div className="blog w-[70vw] min-w-[400px] mx-auto py-[20px]">
                <input
                  type="text"
                  id="title"
                  name="title"
                  value={formValues.title}
                  autoComplete="title"
                  onChange={(e) =>
                    setFormValues((prev) => ({
                      ...prev,
                      title: e.target.value,
                    }))
                  }
                  className={`title w-full min-h-[50px] text-[50px] font-semibold text-[#2d2d2d] resize-none border-none p-2.5 rounded-[10px] placeholder-[#2d2d2d] outline-none ${
                    formErrors.titleError ? "border-red-500" : "border-gray-300"
                  } title w-full min-h-[50px] text-[50px] font-semibold text-[#2d2d2d] resize-none border-none p-2.5 rounded-[10px] placeholder-[#2d2d2d] outline-none`}
                  placeholder="News Title..."
                />
                {formErrors.titleError && (
                  <p className="text-red-500 text-sm">
                    {formErrors.titleError}
                  </p>
                )}
                <textarea
                  id="content"
                  name="content"
                  type="text"
                  value={formValues.content}
                  onChange={(e) =>
                    setFormValues((prev) => ({
                      ...prev,
                      content: e.target.value,
                    }))
                  }
                  className={`article w-full h-[200px] text-[20px] leading-[30px] font-medium text-[#2d2d2d] resize-none border-none p-2 mt-4 rounded-[10px] placeholder-[#2d2d2d] outline-none ${
                    formErrors.contentError
                      ? "border-red-500"
                      : "border-gray-300"
                  } article w-full h-[200px] text-[20px] leading-[30px] font-medium text-[#2d2d2d] resize-none border-none p-2 mt-4 rounded-[10px] placeholder-[#2d2d2d] outline-none`}
                  placeholder="Start Writing here..."
                ></textarea>
                {formErrors.contentError && (
                  <p className="text-red-500 text-sm">
                    {formErrors.contentError}
                  </p>
                )}
                <div className="blog-options bottom-0 left-0 w-full h-[60px] bg-white z-[9] flex justify-center items-center">
                  <button
                    onClick={handleSubmit}
                    className="btn-dark publish-btn bg-gray-800 text-white p-4 px-4 rounded-[10px]"
                  >
                    {loading.loading ? "Sending..." : "Send Notification"}
                  </button>
                </div>
              </div>
            </div>
          </main>
        </React.Fragment>
      </Layout>
    </>
  );
}
